import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
export function KidsPerformanceSection() {
  const kids = [{
    id: 'kid-1',
    name: '佳宝',
    age: '1岁2个月',
    avatar: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80'
  }, {
    id: 'kid-2',
    name: '诚宝',
    age: '2岁6个月',
    avatar: 'https://images.unsplash.com/photo-1519340241574-2cec6aef0c01?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80'
  }];
  return <div className="mb-4" data-id="element-104">
      <h2 className="text-xl font-bold text-gray-800 mb-3 px-1" data-id="element-105">
        孩子成长追踪
      </h2>
      <div className="overflow-x-auto pb-2 -mx-4 px-4" data-id="element-106">
        <div className="flex gap-6 min-w-max" data-id="element-107">
          {kids.map(kid => <Link key={kid.id} to={`/kids-performance/${kid.id}`} className="flex-shrink-0 flex flex-col items-center active:scale-95 transition-transform" data-id="element-108">
              <img src={kid.avatar} alt={kid.name} className="w-16 h-16 rounded-full object-cover border-3 border-indigo-200 mb-2" data-id="element-109" />
              <h3 className="text-sm font-bold text-gray-800 text-center" data-id="element-110">
                {kid.name}
              </h3>
              <p className="text-xs text-gray-600 text-center" data-id="element-111">{kid.age}</p>
            </Link>)}
          <button className="flex-shrink-0 flex flex-col items-center active:scale-95 transition-transform" data-id="element-112">
            <div className="w-16 h-16 bg-amber-700 rounded-full flex items-center justify-center mb-2 border-3 border-amber-600" data-id="element-113">
              <PlusIcon size={24} className="text-white" data-id="element-114" />
            </div>
            <h3 className="text-sm font-bold text-gray-800 text-center" data-id="element-115">
              添加孩子
            </h3>
            <p className="text-xs text-gray-600 text-center" data-id="element-116">Add Child</p>
          </button>
        </div>
      </div>
      <div className="flex justify-center mt-3 gap-1" data-id="element-117">
        {kids.map((_, index) => <div key={index} className="w-2 h-2 rounded-full bg-indigo-300" data-id="element-118"></div>)}
        <div className="w-2 h-2 rounded-full bg-gray-300" data-id="element-119"></div>
      </div>
    </div>;
}